<template>
<div>
     <div class="trackingBox">
                <div class="trakcing-header">
                    <img src="../../images/search.png" />
                    物流追踪
                </div>
                <form @submit.prevent="handleTrackingSubmit">
                <div class="tracking-text">
                    <textarea v-model="nums" name="nums"></textarea>
                </div>
                <div class="trackiing-button">
                    <button type="submit">
                        查询
                    </button>
                </div>
                </form>
            </div>
    <Swiper class="top" :options="swiperOption" interval="10000" duration="2000" ref="swiperRef">
        <Slide class="top1"></Slide>
        <Slide class="top2"></Slide>
        <Slide class="top3"></Slide>
    </Swiper>
</div>
</template>
<script>
import { Swiper, Slide } from '../vueSwiperComponent'

export default {
  name: 'index-top',
  components: {
    Swiper,
    Slide
  },
  data () {
    return {
      nums: '',
      swiperOption: {
        spaceBetween: 30,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    handleResize: function () {
    //   this.$refs.swiperRef.starDom()
      this.$refs.swiperRef.$nextTick(() => {
        console.log(this.$refs.swiperRef, ':this.$refs.swiperRef')
        const offsetWidth = this.$refs.swiperRef.$el.offsetWidth
        this.$refs.swiperRef.$data._width = offsetWidth
      })
    },
    throttle: function (callback, delay) {
      let timeoutId
      return function () {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(callback, delay)
      }
    },
    handleTrackingSubmit () {
      this.$router.push({
        path: '/tracking',
        query: {
          nums: this.nums.replace(/\r?\n/g, ',').trim()
        }
      })
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
    .top1{background-image: url(../../images/top.jpg);
        height:600px;}
    .top2{background-image: url(../../images/top3.jpg);
        height:600px;}
    .top3{background-image: url(../../images/top4.jpg);
        height:600px;}
    .top{
        width:100%;
        height:600px;
        background-repeat: no-repeat;
        background-position-x: center;
        background-position-y: center;
        clear: both;
    }

    .t{
        height: 600px;
        width:1330px;
        margin: 0 auto;;
    }

    .trackingBox{
        z-index: 100;
        position: absolute;
        margin-top:40px;
        left: 65%;
        width: 300px;
        height: 540px;
        background:rgb(112 126 133 / 80%);
        color:#ffffff;
    }
    .tracking-text{
        padding:20px;
    }
    .tracking-text textarea{
        background:transparent;
        color: #ffffff;
        border:none;
        width:250px;
        height:300px;
        border-bottom: 1px #ffffff solid;
        resize: none;
        max-width: 250px;
        max-height: 300px;
        overflow-y:hidden;
        appearance:none;
        outline:none;
        font-size: 16px;
    }
    body *{font-family: "Montserrat", "Microsoft YaHei", "PingFang SC","NotoSansSC", "Microsoft JhengHei", Arial;}
    .trakcing-header{
        margin-top: 20px;
        margin-left: 20px;
        font-size: 18px;
        line-height: 30px;
    }

    .trakcing-header img{
        width:25px;
        vertical-align: middle;
        margin-right: 10px;;
    }

    .trackiing-button{
        margin-left: 20px;;
        margin-top: 10px;
    }

    .trackiing-button button{
        display: block;
        border-radius: 30px;
        width:115px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        color:rgba(0,76,115);
        text-decoration: none;
        font-size: 18px;
        background-color: #ffffff;
        font-weight: 800;
        border-style: solid;
        border-width: 0;
        cursor: pointer;
        appearance:none;
        outline:none;
    }

</style>



// WEBPACK FOOTER //
// src/components/base/index-top.vue